var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-img',{staticClass:"imglog v-btn hidden-sm-and-down",attrs:{"src":require("@/assets/Header/header_logo.png")},on:{"click":_vm.tohome}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }